import { text } from '../Constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getHeaderPrimaryButtonText = ({ isReviewBook, isReschedulePage }) => {
  if (isReviewBook) {
    if (isReschedulePage) {
      return text.SAVE_CHANGES
    }
    return text.BOOK_VISIT
  }
  return text.NEXT
}
